
/**
 * Created by webStorm.
 * @DESC: 功能
 * @User: xiaoxiong
 * @Date: 2022/04/25
 * @Time: 14:30
 */

// 生成路由对象
export function formatRoute (name, path) {
  if (name == 'telite') {
    return {
      path: '/',
      component: () => import('@/views/' + path)
    }
  }

  if (name == 'changwan') {
    return {
      path: '/',
      component: () => import('@/views/' + path)
    }
  }

  return {
    path: '/' + name,
    component: () => import('@/views/' + path)
  }
}



